import React  from "react";
import WidgetApps from "./Apps";
import { useParams } from "react-router-dom";

export function DisplayApps(props) {
    const param = useParams();
    return <WidgetApps param={param} {...props} />
}
